import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Page from "../../components/Page";
import "./index.css";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import CompaniesList from "../../components/CompaniesList";
import UsersList from "../../components/UsersList";
import SystemsList from "../../components/SystemsList";
import FeaturesList from "../../components/FeaturesList";
import OperationHistoryList from "../../components/OperationsHistory";
import { useAuth } from "../../context/AuthContext";
const HEADER_NAME = "";

const Home = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const {
        isAuthenticated,
        isAuthenticating,
        companiesValid,
        companies,
        usersValid,
        users
        // errorLogsValid,
        // errorLogs
    } = useAuth();

    const [tabIndex, setTabIndex] = useState(() => Number(localStorage.getItem("lastTabIndex")) || 0);

    const handleTabChange = (_event: any, newTabIndex: number) => {
        localStorage.setItem("lastTabIndex", String(newTabIndex));
        setTabIndex(newTabIndex);
    };

    useEffect(() => {
        if (location.state?.fromEditPage) {
            setTabIndex(Number(localStorage.getItem("lastTabIndex")) || 0);
        }
    }, [isAuthenticated, isAuthenticating, navigate, location.state]);

    return (
        <Page name={HEADER_NAME} isAuthenticating={isAuthenticating}>
            <Box className="home-container py-3">
                <Box>
                    <Tabs value={tabIndex} onChange={handleTabChange} className="px-4">
                        <Tab data-cy="company-tab" label={<Typography variant="h5">Company</Typography>} />
                        <Tab data-cy="user-tab" label={<Typography variant="h5">User</Typography>} />
                        <Tab data-cy="system-tab" label={<Typography variant="h5">System</Typography>} />
                        <Tab data-cy="feature-tab" label={<Typography variant="h5">Features</Typography>} />
                        <Tab data-cy="errorLog-tab" label={<Typography variant="h5">Error Log</Typography>} />
                        <Tab
                            data-cy="operationHistory-tab"
                            label={<Typography variant="h5">Operation History</Typography>}
                        />
                    </Tabs>
                </Box>
                <Box sx={{ padding: 2 }}>
                    {tabIndex === 0 && (
                        <Box className="companies-container py-3">
                            <CompaniesList companiesValid={companiesValid} companies={companies} />
                        </Box>
                    )}
                    {tabIndex === 1 && (
                        <Box className="users-container py-3">
                            <UsersList usersValid={usersValid} users={users} />
                        </Box>
                    )}
                    {tabIndex === 2 && (
                        <Box className="systems-container py-3">
                            <SystemsList />
                        </Box>
                    )}
                    {tabIndex === 3 && (
                        <Box className="features-container py-3">
                            <FeaturesList />
                        </Box>
                    )}
                    {tabIndex === 4 && (
                        <Box className="errorlogs-container py-3">
                            <Typography variant="h5" sx={{ alignText: "center", alignContent: "center" }}>
                                Work in progress. Will be fixed soon{" "}
                            </Typography>
                        </Box>
                    )}

                    {tabIndex === 5 && <OperationHistoryList />}
                </Box>
            </Box>
        </Page>
    );
};

export default Home;
